angular.module('app').config(transportationContentsRouting);

function transportationContentsRouting($routeProvider) {
  $routeProvider
    .when('/transportation_contents', {
      pageTitle: 'TRANSPORTATION',
      template: '<transportation-contents-page></transportation-contents-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        // ajs: true,
      },
      menu: 'websites',
      accessPermission: 'index_transportation_accountadmin',
      authReq: true,
    })
    .when('/transportation_contents/new', {
      pageTitle: 'ADD_CONTENT',
      template: '<transportation-content-page></transportation-content-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        // ajs: true,
      },
      // breadcrumb: {
      //   label: 'TRANSPORTATION',
      //   parent: 'transportation_contents',
      // },
      menu: 'websites',
      accessPermission: 'create_transportation_accountadmin',
      authReq: true,
    })
    .when('/transportation_contents/:id', {
      pageTitle: 'CONTENT_OVERVIEW',
      template: '<transportation-content-page></transportation-content-page>',
      breadcrumb: {
        label: 'WEBSITES',
        parent: 'ng/websites',
        // ajs: true,
      },
      // breadcrumb: {
      //   label: 'TRANSPORTATION',
      //   parent: 'transportation_contents',
      // },
      menu: 'websites',
      accessPermission: 'show_transportation_accountadmin',
      authReq: true,
    });
}

transportationContentsRouting.$inject = ['$routeProvider'];
